import { createAction } from 'redux-actions';

export const currentBlacklineViewChangesLoading = createAction(
  'CURRENT_BLACKLINE_VIEW_CHANGES_LOADING',
);
export const currentBlacklineViewChangesLoaded = createAction(
  'CURRENT_BLACKLINE_VIEW_CHANGES_LOADED',
);
export const currentBlacklineViewChangesError = createAction(
  'CURRENT_BLACKLINE_VIEW_CHANGES_ERROR',
);
export const previousBlacklineViewChangesLoading = createAction(
  'PREVIOUS_BLACKLINE_VIEW_CHANGES_LOADING',
);
export const previousBlacklineViewChangesLoaded = createAction(
  'PREVIOUS_BLACKLINE_VIEW_CHANGES_LOADED',
);
export const previousBlacklineViewChangesError = createAction(
  'PREVIOUS_BLACKLINE_VIEW_CHANGES_ERROR',
);
